console.log(process.env)

// 打包的目标环境
const ENV = process.env.ENV

const ENV_HOST = {
  // local: { // 本地环境对应的接口配置
  //   host: '//localhost:8060',
  //   singleSignUrl: 'http://localhost:8083/#/login',
  //   callbackUrl: 'http://localhost:8089/#/home',
  //   VolunteerHomeUrl: 'http://localhost:8083/#/home',
  //   uploadUrl: 'http://localhost:8060/file/upload',
  //   singleSignOn : false
  // },
  local: { // 本地环境对应的接口配置  
    host: 'https://hengshan.api.hk952183.com', // 横山后端接口地址
    singleSignUrl: 'http://192.168.31.113:8083/#/login',
    callbackUrl: 'http://192.168.31.113:8089/#/home',
    VolunteerHomeUrl: 'http://192.168.31.113:8083/#/home',
    uploadUrl: 'http://192.168.31.113:8060/file/upload',
    singleSignOn : false
  },
  tencent: { // 我们的测试环境，腾讯云
    host: '//118.24.54.72:8060',
    singleSignUrl: 'http://www.hk952183.com:40809/#/login',
    callbackUrl: 'http://118.24.54.72/#/home',
    VolunteerHomeUrl: 'http://www.hk952183.com:40809/#/home',
    uploadUrl: 'http://118.24.54.72:8060/file/upload',
    singleSignOn : false
  },
  test: { // 客户的测试环境
    host: '//www.hk952183.com:32180/rest',
    singleSignUrl: 'http://www.hk952183.com:40809/#/login',
    callbackUrl: 'http://www.hk952183.com:32180/#/home',
    VolunteerHomeUrl: 'http://www.hk952183.com:40809/#/home',
    uploadUrl: 'http://www.hk952183.com:32180/rest/file/upload',
    singleSignOn : false
  },
  prod: { // 客户的正式环境
    host: 'https://hengshan.api.hk952183.com', // 横山后端接口地址
    singleSignUrl: 'http://jujia.hk952183.com/#/login', // 居家平台登陆地址
    callbackUrl: 'https://hengshan.hk952183.com/#/home', // 居家登陆成功之后跳转的横山首页
    VolunteerHomeUrl: 'http://jujia.hk952183.com/#/home', // 居家平台首页，从横山链接过去需要
    uploadUrl: 'https://hengshan.api.hk952183.com/file/upload', // 横山图片上传接口
    singleSignOn : true
  }
}

console.log(ENV_HOST[ENV])

const HOST = ENV_HOST[ENV] || ENV_HOST['prod']

console.log(HOST)

export default HOST



// WEBPACK FOOTER //
// ./src/config/ENV.js